import { Injectable } from '@angular/core';
// // // import { Socket } from 'ngx-socket-io';
// import { SimpleUser, SimpleUserDelegate, SimpleUserOptions } from "../sip/simple-user";
// import { getAudio, getButton, getButtons, getInput, getSpan } from "../sip/simple-user/demo-utils";
import { GlobalsService } from '../services/globals.service';
import * as JsSIP from './jssip.js';
import { Els } from '../services/els.service';

// const serverSpan = "server";
// const targetSpan = "target";
// const connectButton = getButton("connect");
// const callButton = getButton("call");
// const hangupButton = getButton("hangup");
// const disconnectButton = getButton("disconnect");
//  const audioElement = getAudio("remoteAudio");
// const keypad = getButtons("keypad");
// const dtmfSpan = "dtmf";
// const webSocketServer = "ws://ws.reachme.com:8080";
// // const webSocketServer = "wss://wss.reachme.com:8080/sip/";
// const target = "sip:531.24117@ws.reachme.com:8080";
// const displayName = "Shon 531";

@Injectable({providedIn: 'root'})

export class SocketIO {
  soc;
  ua
  remoteAudio = document.getElementById ('remoteAudio') as HTMLAudioElement;

  constructor(
    // // // private socket: Socket,
    private gs: GlobalsService,
    private els: Els,
  ) {}

  goSMS (to, body) {
    var eventHandlers = {
      'succeeded': function(data){ console.log( data); },
      'failed':    function(data){ console.log( data); },
    };
    var options = {  'eventHandlers': eventHandlers };
    this.ua.sendMessage('sip:'+ to + '@sip2.reachme.com', body, options);
  }

  sipConnect (user, psw, server) {
    var socket = new JsSIP.WebSocketInterface(server);


 // socket.via_transport = "UDP";
  socket.via_transport = "WS";




    var configuration = {
      sockets : [ socket ],
      register: true,
      uri : 'sip:'+ user + '@sip2.reachme.com', 
      password : psw,
   //    ws_servers: "sip2.reachme.com:443",
    //   registrar_server: 'sip2.reachme.com:5867',
    //  use_preloaded_route: true,
      register_expires: 700,

    };

    this.ua = new JsSIP.UA(configuration);
    this.ua.start();
  
    this.ua.on("registered", function(){
      console.log( 'registered ++++++++++++++++++++++++++++');
    });

}

goCall (num) {
  //if (!JsSIP.rtcninja.hasWebRTC()) {alert("WebRTC is not supported. Please use another browser."); }
  let eventHandlers = {
    'progress':   function(data){ console.log( data);  },
    'failed':     function(data){ console.log( data);  },
    'confirmed':  function(data){ console.log( data);  },
    'ended':      function(data){ console.log( data);  }
  };

  //{ 'urls': 'turn:example.com', 'username': 'foo', 'credential': ' 1234' }

  var callOption = {
    eventHandlers: eventHandlers,
     extraHeaders: [ 'X-Foo: foooooooooooooooooooOOOOOOOOOOOOOOOOOOO', 'X-Bar: bar' ],
    mediaConstraints: {'audio': true, 'video': false},
    rtcOfferConstraints: {'offerToReceiveAudio': true, 'offerToReceiveVideo': false},
    sessionTimersExpires: 7200,
   // pcConfig: {'iceServers': [{'urls': ['stun:stun.l.google.com:19302','stun:stun1.l.google.com:19302']}]}
  
  };

  this.ua.call('sip:' + num + '@sip2.reachme.com', callOption);

  // ua.connection.onaddstream = function(e) { remoteAudio.srcObject = e.stream; 

  this.ua.on("newRTCSession", function(data){
    console.log( data); 
    var session = data.session; // outgoing call session here
    var dtmfSender;


    if (session.direction === "incoming") {
      console.log( 'incoming*********incoming'); 


      var callOptions = {
        mediaConstraints: {
          audio: true, // only audio calls
          video: false
        }
      };
      
      var session = data.session; 
    
      if (session.direction === "incoming") {
          // incoming call here
          session.on("accepted",function(){
            console.log( 'accepted-------------');
          });
          session.on("confirmed",function(){
            console.log( 'confirmed');
            var localStream = session.connection.getLocalStreams()[0];
            dtmfSender = session.connection.createDTMFSender(localStream.getAudioTracks()[0])
          });
          session.on("ended",function(){ console.log( 'ended------------'); });
          session.on("failed",function(){ console.log( 'failed-------------'); });
          session.on('addstream', function(e){
              // set remote audio stream (to listen to remote audio)
              // remoteAudio is <audio> element on page
             console.log( 'addstream');
              this.remoteAudio.src = window.URL.createObjectURL(e.stream);
              this.remoteAudio.play();

          });
          

          session.answer(callOptions);

      // session.terminate();
        }
  }


    // dtmfSender.insertDTMF("1");
    // dtmfSender.insertDTMF("#");
    // session.mute({audio: true});
    // session.unmute({audio: true});
    // session.terminate();
  });
}


















goSip () {

    try {
      // if (this.soc !== undefined && this.soc.readyState != 1) {
      // // // if (this.soc === undefined || this.soc.readyState != 1) {
        // soc = new WebSocket('ws://a.reachme.com:4445', ['websocket', 'sip', 'reachme']);
        this.soc = new WebSocket('wss://a.reachme.com/sock/', ['websocket', 'sip', 'reachme']);
       //  this.soc = new WebSocket('wss://wss.reachme.com:8080/sip/', ['websocket', 'sip', 'reachme']);
  
        //console.log('open oooooooooooooooooooooooooo ' +this.soc.readyState);
  
        this.soc.addEventListener('error', (event) => {  this.socOpen1 (event)   });
        this.soc.addEventListener('open', (event) => {  this.socOpen1 (event)   });
        this.soc.addEventListener('close', (event) => {  this.socOpen1 (event)   });
        this.soc.addEventListener('message', (event) => {  this.socMsg (event.data)   });
        window.addEventListener('beforeunload', () => {this.soc.close();});
      // // // }
     
    } catch (err) {console.error(err)}

}
socOpen1 (event) {
  console.log( event['type'] + ' == ' +this.soc.readyState);
  if (event['type'] == 'open') {
    
    if (this.gs.isOnline == 0) this.goReg ('532.24117'); 
    this.gs.isOnline = 1;
    // this.els.hideUnhideElement ('onlineIco' , 'block');

    this.goInvite ('532.24117'); 
  } 
  if (event['type'] == 'close' || event['type'] == 'error') {
    this.gs.isOnline= 0;
    // this.els.hideUnhideElement ('onlineIco' , 'none');
  }
  // console.log( event['type']);
}

goInvite (id) {
  let s = '??rpsw?' + this.gs.rpsw
  s += '??inv?' + id;
  this.soc.send(s);
}


goReg (id) {
  let s = '??rpsw?' + this.gs.rpsw
  s += '??reg?' + id;
  this.soc.send(s);
}

  // hideUnhideElement (id, display) {
  //   var el = document.getElementById(id); 
  //   if (el != null) { el.setAttribute('style', 'display:' + display + ';');}
  //   else {console.error (id + ' NOT FOUND')}
  // }
  socOpen (event) {
    console.log( event['type'] + ' == ' +this.soc.readyState);
    if (event['type'] == 'open') {
      this.soc.send(('rpsw: ' + this.gs.rpsw)); 
      this.gs.isOnline= 1;
      this.els.hideUnhideElement ('onlineIco' , 'block');
    } 
    if (event['type'] == 'close' || event['type'] == 'error') {
      this.gs.isOnline= 0;
      this.els.hideUnhideElement ('onlineIco' , 'none');
    }
    // console.log( event['type']);
  }

  socMsg (message) {
  console.log('Message from server ', message);
  }

  goOnline () {
    try {
    // if (this.soc !== undefined && this.soc.readyState != 1) {
    if (this.soc === undefined || this.soc.readyState != 1) {
      // soc = new WebSocket('ws://a.reachme.com:4445', ['websocket', 'sip', 'reachme']);
      // this.soc = new WebSocket('wss://a.reachme.com/sock/', ['websocket', 'sip', 'reachme']);
      this.soc = new WebSocket('wss://wss.reachme.com:8080/sip/', ['websocket', 'sip', 'reachme']);

      //console.log('open oooooooooooooooooooooooooo ' +this.soc.readyState);

      this.soc.addEventListener('error', (event) => {  this.socOpen (event)   });
      this.soc.addEventListener('open', (event) => {  this.socOpen (event)   });
      this.soc.addEventListener('close', (event) => {  this.socOpen (event)   });
      this.soc.addEventListener('message', (event) => {  this.socMsg (event.data)   });
      window.addEventListener('beforeunload', () => {this.soc.close();});
    }

  } catch (err) {console.error(err)}
  }


  // goOnline () {
  //   const soc = new WebSocket('ws://a.reachme.com:4445', ['websocket', 'sip', 'reachme']);
  //  //  const soc = new WebSocket('ws://a.reachme.com:4445', 'websocket');
  //   soc.addEventListener('error', (event) => {  this.socOpen (soc, event)   });
  //   soc.addEventListener('open', (event) => {  this.socOpen (soc, event)   });
  //   soc.addEventListener('close', (event) => {  this.socOpen (soc, event)   });
  //   soc.addEventListener('message', (event) => {  this.socMsg (soc, event.data)   });
  //   window.addEventListener('beforeunload', function() {soc.close();});
  //   // soc.onopen = function() {console.log('Opened connection 🎉');var json = JSON.stringify({ message: 'Hello 👋' }); soc.send(json);    }
  //   // soc.onmessage = function(event) {console.log(event.data);}
  //   // soc.onerror = function(event) {console.log(event);}
  //   // soc.onclose = function(code, reason) { console.log(code, reason); }
  // }

    // arrayBuffer2str(buf) {
    //   var str= '';
    //   var ui8= new Uint8Array(buf);
    //   for (var i= 0 ; i < ui8.length ; i++) {
    //     str= str+String.fromCharCode(ui8[i]);
    //   }
    //   return str;
    // }
    //   str2arrayBuffer(str) {
    //   var buf= new ArrayBuffer(str.length);
    //   var bufView= new Uint8Array(buf);
    //   for (var i= 0 ; i < str.length ; i++) {
    //     bufView[i]= str.charCodeAt(i);
    //     }
    //   return buf;
    // }
    // sendPacket(ipAddr,ipPort,data) {
    //   var delay= 5000;	/// 5 seconds timeout
    //   (<any>window).chrome.sockets.tcp.create({}, createInfo => { //callback function with createInfo as the parameter
    //     var _socketTcpId= createInfo.socketId;
    //     (<any>window).chrome.sockets.tcp.connect(_socketTcpId, ipAddr, ipPort, result => { //callback function with result as the parameter
    //       if (result === 0) {
    //         var data2send= this.str2arrayBuffer(data);
    //         (<any>window).chrome.sockets.tcp.send(_socketTcpId, data2send);
    //       }
    //     });
    //     (<any>window).chrome.sockets.tcp.onReceive.addListener( info => { //callback function with info as the parameter
    //       (<any>window).chrome.sockets.tcp.close(_socketTcpId);
    //       var data= this.arrayBuffer2str(info.data);
    //     });
    //     setTimeout(function() {(<any>window).chrome.sockets.tcp.close(_socketTcpId);}, delay);
    //   });
    // }

}

// export class FileSys {
//   async fileWrite() {
//     try {
//       const result = await Filesystem.writeFile({
//         path: 'secrets/text.txt',
//         data: "This is a test",
//         directory: FilesystemDirectory.Documents,
//         encoding: FilesystemEncoding.UTF8
//       })
//       console.log('Wrote file', result);
//     } catch(e) {
//       console.error('Unable to write file', e);
//     }
//   }
  
//   async fileRead() {
//     let contents = await Filesystem.readFile({
//       path: 'secrets/text.txt',
//       directory: FilesystemDirectory.Documents,
//       encoding: FilesystemEncoding.UTF8
//     });
//     console.log(contents);
//   }
  
//   async fileAppend() {
//     await Filesystem.appendFile({
//       path: 'secrets/text.txt',
//       data: "MORE TESTS",
//       directory: FilesystemDirectory.Documents,
//       encoding: FilesystemEncoding.UTF8
//     });
//   }
  
//   async fileDelete() {
//     await Filesystem.deleteFile({
//       path: 'secrets/text.txt',
//       directory: FilesystemDirectory.Documents
//     });
//   }
  
//   async mkdir() {
//     try {
//       let ret = await Filesystem.mkdir({
//         path: 'secrets',
//         directory: FilesystemDirectory.Documents,
//         recursive: false // like mkdir -p
//       });
//     } catch(e) {
//       console.error('Unable to make directory', e);
//     }
//   }
  
//   async rmdir() {
//     try {
//       let ret = await Filesystem.rmdir({
//         path: 'secrets',
//         directory: FilesystemDirectory.Documents,
//         recursive: false,
//       });
//     } catch(e) {
//       console.error('Unable to remove directory', e);
//     }
//   }
  
//   async readdir() {
//     try {
//       let ret = await Filesystem.readdir({
//         path: 'secrets',
//         directory: FilesystemDirectory.Documents
//       });
//     } catch(e) {
//       console.error('Unable to r ead dir', e);
//     }
//   }
  
//   async stat() {
//     try {
//       let ret = await Filesystem.stat({
//         path: 'secrets/text.txt',
//         directory: FilesystemDirectory.Documents
//       });
//     } catch(e) {
//       console.error('Unable to stat file', e);
//     }
//   }
  
//   async readFilePath() {
//     // Here's an example of reading a file with a full file path. Use this to
//     // r ead binary data (base64 encoded) from plugins that return File URIs, such as
//     // the Camera.
//     try {
//       let data = await Filesystem.readFile({
//         path: 'file:///var/mobile/Containers/Data/Application/22A433FD-D82D-4989-8BE6-9FC49DEA20BB/Documents/text.txt'
//       })
//     }catch(e) {
//       console.error('Unable to rename file', e);
//     }
//   }
  
//   async rename() {
//     try {
//       // This example moves the file within the same 'directory'
//       let ret = await Filesystem.rename({
//         from: 'text.txt',
//         to: 'text2.txt',
//         directory: FilesystemDirectory.Documents
//       });
//     } catch(e) {
//       console.error('Unable to rename file', e);
//     }
//   }
  
//   async copy() {
//     try {
//       // This example copies a file within the documents directory
//       let ret = await Filesystem.copy({
//         from: 'text.txt',
//         to: 'text2.txt',
//         directory: FilesystemDirectory.Documents
//       });
//     } catch(e) {
//       console.error('Unable to copy file', e);
//     }
//   }
// }

export class SocketIO1 {
declare window: any;

 audioContext = new(window.AudioContext )(); // Our audio context
 source = null; // This is the BufferSource containing the buffered audio


// Used the File API in order to asynchronously obtain the bytes of the file that the user selected in the 
// file input box. The bytes are returned using a callback method that passes the resulting ArrayBuffer. 
obtainMp3BytesInArrayBufferUsingFileAPI(selectedFile, callback) {

  var reader = new FileReader();
  reader.onload = function(ev) {
    // The FileReader returns us the bytes from the computer's file system as an ArrayBuffer  
    var mp3BytesAsArrayBuffer = reader.result;
    callback(mp3BytesAsArrayBuffer);
  }
  reader.readAsArrayBuffer(selectedFile);

}


 decodeMp3BytesFromArrayBufferAndPlay(mp3BytesAsArrayBuffer) {

  // The AudioContext will asynchronously decode the bytes in the ArrayBuffer for us and return us
  // the decoded samples in an AudioBuffer object.  
  this.audioContext.decodeAudioData(mp3BytesAsArrayBuffer, function(decodedSamplesAsAudioBuffer) {

    // Clear any existing audio source that we might be using
    if (this.source != null) {
      this.source.disconnect(this.audioContext.destination);
      this.source = null; // Leave existing source to garbage collection
    }

    // In order to play the decoded samples contained in the audio buffer we need to wrap them in  
    // an AudioBufferSourceNode object. This object will stream the audio samples to any other 
    // AudioNode or AudioDestinationNode object. 
    this.source = this.audioContext.createBufferSource();
    this.source.buffer = this.decodedSamplesAsAudioBuffer; // set the buffer to play to our audio buffer
    this.source.connect(this.audioContext.destination); // connect the source to the output destinarion 
    this.source.start(0); // tell the audio buffer to play from the beginning
  });

}


// Assign event handler for when the 'Play' button is clicked
onclick = function(event) {

  event.stopPropagation();

  // I've added two basic validation checks here, but in a real world use case you'd probably be a little more stringient. 
  // Be aware that Firefox uses 'audio/mpeg' as the MP3 MIME type, Chrome uses 'audio/mp3'. 
  var fileInput = document.forms[0].mp3FileSelect;
  if (fileInput.files.length > 0 && ["audio/mpeg", "audio/mp3"].includes(fileInput.files[0].type)) {

    // We're using the File API to obtain the MP3 bytes, here but they could also come from an XMLHttpRequest 
    // object that has downloaded an MP3 file from the internet, or any other ArrayBuffer containing MP3 data. 
    this.obtainMp3BytesInArrayBufferUsingFileAPI(fileInput.files[0], function(mp3BytesAsArrayBuffer) {

      // Pass the ArrayBuffer to the decode method
      this.decodeMp3BytesFromArrayBufferAndPlay(mp3BytesAsArrayBuffer);

    });

  } else alert("Error! No attached file or attached file was of the wrong type!");

}

}